import { createAsyncThunk } from '@reduxjs/toolkit';

import { authGet } from '../../utils/request';

const getJobsFailed = createAsyncThunk('jobs/getJobsFailed',
  async (params, { rejectWithValue }) => {
    try {
      const { data } = await authGet('/jobs/failed',
        {
          params
        });
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });

export default getJobsFailed;
